module.exports = __webpack_public_path__ + "static/ftc_logo-92773cdda13c913ad4cbd904cbf82680.png";